import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type LeadMagnetProps = CtaShellProps

export function LeadMagnet(props: LeadMagnetProps) {
	return <CtaShell {...props} layout="split-form" actionType="download" form={props.form ?? { fields: [{ name: "email", label: "Work email", type: "email", required: true }], submitLabel: "Get the report", successMessage: "The report is on its way." }} />
}

